import React from 'react';
import './superAdminCalendar.css';

const Calendar = ({ onClick }) => {
	return (
		<button onClick={onClick} type="button">
			<div className="cal-wrapper flex flex-col items-center">
				<div className="cal-ico-wrapper">
					<img alt="calendar" className="calendar" src="assets/images/schoolAdminTopNav/date.svg" />
				</div>
				<div className="cal-text">{`${new Date().getDate()}, ${new Date().toString().slice(0, 3)}`}</div>
			</div>
		</button>
	);
};

export default Calendar;
